/**
 * Appends base s3 public url for test data files
 * @param file key which contains relative path for test files
 */
export const getFullTestDataFileURL = (fileKey: string) => {
  if (!fileKey) return '';
  return `https://lightout-portal.s3.us-west-2.amazonaws.com/${fileKey}`;
};
